"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Breakpoints = void 0;
const Breakpoints = () => ({
    ms: 576,
    xs: 375,
    sm: 768,
    md: 1024,
    ml: 1360,
    lg: 1440,
    xl: 1920,
});
exports.Breakpoints = Breakpoints;
